// in-memory tracking of a current item in a collection (cursor)
export default {
  initCursor () {
    this.index = -1 // next must be called to get to first item
  },

  currentItem () {
    return this.at(this.index)
  },

  nextItem () {
    if (this.hasNext()) {
      this.index += 1
      this.triggerItemChanged()
    }
  },

  previousItem () {
    if (this.hasPrevious()) {
      this.index -= 1
      this.triggerItemChanged()
    }
  },

  hasNext () {
    return this.index < this.size() - 1
  },

  hasPrevious () {
    return this.index > 0
  },

  findItemIndex (item) {
    return this.findIndex((i) => item.id == i.id)
  },

  triggerItemChanged () {
    this.trigger('change_item', this.currentItem())
  },
}
